import { BulkResizeState } from "../../../types";
import { getRotationOperation } from "../../../utils/operations/getRotationOperation";

interface IPayload {
    payload: {
        value: number;
        imageId: string;
    };
}

export const setRotation = (state: BulkResizeState, { payload: { value, imageId } }: IPayload) => {
    const image = state.images.find((image) => image.id === imageId);
    if (!image) throw new Error("image not found");
    image.operations.push(getRotationOperation(image, value));
    image.rotate.rotation = value;

    // flip the dimensions
    const originalWidth = image.original.width;
    const originalHeight = image.original.height;

    image.original.width = originalHeight;
    image.original.height = originalWidth;

    const previewWidth = image.preview.width;
    const previewHeight = image.preview.height;

    image.preview.width = previewHeight;
    image.preview.height = previewWidth;
};
